import React from 'react'
import './about.css'

import logo from './images/nynfc_logo.png'

function About() {
return (
<div className="container-fluid about-fluid bg-light">
    <div className="container about-container">
        <div className="about-nynfc-logo">
            <img src={logo} alt="" className="about-nynfc-img" />
        </div>
        <div className="about-info">
            <div className="about-info-heading">
            <h1 className="about-h1">ABOUT
            <span className="txt-color">US</span></h1>
        </div>
        <div className="about-desc">
            <p className="text-justify text-dark">
            <strong>VISION:</strong> Our vision Lorem ipsum dolor sit amet, consectetur adipiscing elit,
            sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis
            nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
            labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
            nisi ut aliquip ex ea commodo consequat.consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
            labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
            nisi ut aliquip ex ea commodo consequat.
            </p>
            <div className="about-info-button">Read More</div>
            </div>
        </div>
    </div>
</div>
)
}

export default About